module.exports = __webpack_public_path__ + "img/SKWINKELNetActieActieplanningA1BD39.f51ddc65.png";